export type UUID = string;

const uuidv1 = require("uuid/v1");

export function newUuid(): UUID {
  return uuidv1();
}
